import { Injectable } from '@angular/core';
import { Person } from 'src/app/_model/person';
import { Resetable } from '../../resetter/resetable';
import { IMSId } from 'src/app/_model/ims-object';

@Injectable()
export abstract class PersonsDaoService implements Resetable {
  public abstract savePersons(persons: Person[]): Promise<void>;
  public abstract createPerson(person: Person): Promise<Person>;
  public abstract deleteLocalPerson(id: IMSId): Promise<void>;
  /** Edits a locally created person in place. */
  public abstract updateLocalPerson(person: Person): Promise<void>;
  /**
   * Records an edit to a *synced* person. Stored apart from the synced row
   * itself, which every sync overwrites - see LocalPersonOverridesDbTableDefinition.
   */
  public abstract savePersonOverride(person: Person): Promise<void>;
  public abstract getPersons(): Promise<Person[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
